import { FC, PropsWithChildren, useEffect } from 'react';
import { createBlockerStore } from './createBlockerStore';

const { Provider, useStore: useUserSelectBlockers } = createBlockerStore();

const UserSelectBlocker: FC = () => {
  const { has } = useUserSelectBlockers();

  useEffect(() => {
    if (has) {
      const original = document.body.style.userSelect;
      document.body.style.userSelect = 'none';
      return () => {
        document.body.style.userSelect = original;
      };
    }
  }, [has]);

  return null;
};

const UserSelectBlockingProvider: FC<PropsWithChildren> = ({ children }) => (
  <Provider>
    <UserSelectBlocker />
    {children}
  </Provider>
);

export { UserSelectBlockingProvider, useUserSelectBlockers };
